import React from 'react';

const Search: React.VFC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.625 13.8572H14.6375L14.2875 13.5197C15.5125 12.0947 16.25 10.2447 16.25 8.23218C16.25 3.74468 12.6125 0.107178 8.125 0.107178C3.6375 0.107178 0 3.74468 0 8.23218C0 12.7197 3.6375 16.3572 8.125 16.3572C10.1375 16.3572 11.9875 15.6197 13.4125 14.3947L13.75 14.7447V15.7322L20 21.9697L21.8625 20.1072L15.625 13.8572ZM8.125 13.8572C5.0125 13.8572 2.5 11.3447 2.5 8.23218C2.5 5.11968 5.0125 2.60718 8.125 2.60718C11.2375 2.60718 13.75 5.11968 13.75 8.23218C13.75 11.3447 11.2375 13.8572 8.125 13.8572Z" fill="#777777" />
  </svg>
);

export default Search;
